import React, { useEffect, useState } from "react";

import Login from "./components/login.jsx";
import CentrikaHome from "./components/centrika/home.jsx";

import OperatorViewer from "./components/centrika/operator_viewer.jsx";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
} from "react-router-dom";

import { renderToStaticMarkup } from "react-dom/server";
import { withLocalize } from "react-localize-redux";

import translations_en from "./translations/en.translations.json";
import translations_rw from "./translations/rw.translations.json";
import translations_fr from "./translations/fr.translations.json";

import { SnackbarProvider } from "notistack";
// operator

import HomeOperator from "./components/operator/home.jsx";

import Outlet from "./components/operator/outletes.jsx";
import HomeAgent from "./components/agent/home.jsx";
import { Typography } from "@material-ui/core";

import HomeIndividual from "./components/individual_agent/home.jsx";
import HomeAcgroup from "./components/ac_group/home.jsx";

import LandingHome from "./components/landing/landing_home";
import NotFound from "./components/centrika/pages/404";
import ConfirmEmail from "./components/landing/confirm_email";
import ResetPassword from "./components/landing/reset_password";
import PreRegistration from "./components/landing/pre_registration";
import TopUp from "./components/landing/top_up";
import Redirection from "./components/landing/redirection";
import CheckBalance from "./components/landing/check_balance";
import OtpVerification from "./components/landing/otp_verification";

const axios = require("axios");
// agent

function getSubdomain() {
  let host = window.location.host;
  let protocol = window.location.protocol;
  let parts = host.split(".");
  let subdomain = "";
  // If we get more than 3 parts, then we have a subdomain
  // INFO: This could be 4, if you have a co.uk TLD or something like that.
  if (parts.length >= 3) {
     subdomain = parts[0];

    return true;
  }
  return false;
}
function Translator(props) {
  const [sub, setSub] = useState(getSubdomain());

  useEffect(() => {
    props.initialize({
      languages: [
        { name: "Kinyarwanda", code: "rw" },
        { name: "English", code: "en" },
        { name: "Francais", code: "fr" },
      ],

      translation: translations_rw,
      options: { renderToStaticMarkup, defaultLanguage: "en" },
    });

    var data = {};
    const data1 = localStorage.getItem("nx_cent");
    if (data1 != null) {
      data = JSON.parse(data1);
    }

    props.addTranslationForLanguage(translations_rw, "rw");
    props.addTranslationForLanguage(translations_en, "en");
    props.addTranslationForLanguage(translations_fr, "fr");
  }, []);

  return (
    <SnackbarProvider
      preventDuplicate
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      maxSnack={2}
    >
      <Router>
        <Switch>
          <Route
            exact
            path="/"
            component={() => (!sub ? <LandingHome /> : <Login {...props} />)}
          />
          <Route path="/login" component={() => <Login {...props} />} />
          <Route path="/landing" component={() => <LandingHome {...props} />} />
          <Route
            path="/centrika/operator"
            component={() => <OperatorViewer {...props} />}
          />
          <Route
            path="/centrika"
            component={() => <CentrikaHome {...props} />}
          />
          <Route
            path="/operator"
            component={() => <HomeOperator {...props} />}
          />
          <Route
            exact
            path="/centrika/operator"
            component={() => <HomeOperator {...props} />}
          />
          <Route path="/agent" component={() => <HomeAgent {...props} />} />
          <Route
            exact
            path="/individual"
            component={() => <HomeIndividual {...props} />}
          />
          <Route
            path="/confirmEmail"
            component={() => <ConfirmEmail {...props} />}
          />

            <Route
            path="/resetPassword"
            component={() => <ResetPassword {...props} />}
          />
          <Route
            path="/preRegister"
            component={() => <PreRegistration {...props} />}
          />
           <Route
            path="/card-topup"
            component={() => <TopUp {...props} />}
          />
          <Route
            path="/checkBalance"
            component={() => <CheckBalance {...props} />}
          />
           <Route
            path="/success/:token"
            component={(props) => <Redirection {...props} />}
          />

          <Route
            path="/otpVerification/:ext_ref_no"
            component={(props) => <OtpVerification {...props} />}
          />

          <Route
            exact
            path="/ac_group/home"
            component={() => <HomeAcgroup {...props} />}
          />

          <Route
            exact
            path="/ac_group/ticketsAcGroup"
            component={() => <HomeAcgroup {...props} />}
          />

          <Route
            exact
            path="/ac_group/settlementReport"
            component={() => <HomeAcgroup {...props} />}
          />

          <Route
            exact
            path="/ac_group/ticketsCentrika"
            component={() => <HomeAcgroup {...props} />}
          />

          <Route
            path="/centrika/operator"
            component={() => <OperatorViewer {...props} />}
          />

          <Route component={() => <NotFound full={true} />} />
        </Switch>
      </Router>
    </SnackbarProvider>
  );
}

export default withLocalize(Translator);